<template>
    <div id="banner">
        <div class="view">
            <div class="swiper-container" @mouseenter="thumbMoved" @mouseleave="thumbLeaved">
                <div class="swiper-wrapper" >
                    <div class="swiper-slide" v-if="bannerList.length>0" v-for="(url,index) in bannerList" :key="index">
                        <div @click="showMask" v-if="special=='10' && index==0">
                            <img :src="url" class="boxImg" alt="">
                            <img src="@/assets/imgs/video.png" class="video" alt="">
                        </div>
                        <div class="bigmask" v-if="type=='friend'&&index!=0"></div>
                        <img @click="lookImg" :src="url" class="boxImg" v-if="special!='10'" alt="">
                    </div>
                </div>
            </div>
            <preview ref="preview" original-width="580" original-height="450" ratio="3"></preview>
        </div>
        <div class="preview" v-if="bannerList.length>0">
            <a class="arrow-left" href="javascript:;" @click="arrowLeft"></a>
            <a class="arrow-right" href="javascript:;" @click="arrowRight"></a>
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div :class="previewImgSelected == index ? 'swiper-slide active-nav' : 'swiper-slide'" v-for="(url, index) in bannerList">
                        <img :src="url" alt="" @mouseenter="forbidImgDrag">
                        <div class="imgmask" v-if="type=='friend'&&index!=0"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper'
import preview from './preview'
export default {
    props:['bannerList','special','type'],
    components:{
        Swiper,
        preview
    },
    data() {
        return {
            showStatus:true,
            previewImgSelected: 0
        }
    },
    created() {
        // console.log(this.type)
    },
    mounted () {
        this.$nextTick(() => {        
            let _this = this
            let _viewSwiper = this.viewSwiper = new Swiper('.view .swiper-container', {
                on: {
                    slideChangeTransitionStart() {
                        _this.updateNavPosition()
                    }
                }
            })
            let _previewSwiper = this.previewSwiper = new Swiper('.preview .swiper-container', {
                slidesPerView: "auto",
                allowTouchMove: false,
                preventClicksPropagation: false,
                on: {
                    tap() {
                        _viewSwiper.slideTo(_previewSwiper.clickedIndex)
                    }
                }
            })
        })
    },
    methods: {
        showMask() {
            this.$emit('func',this.showStatus)
        },
        // 查看大图
        lookImg() {
            console.log('查看大图')
        },
        arrowLeft(e) {
            e.preventDefault()
            this.$nextTick(() => {
                if (this.viewSwiper.activeIndex == 0) {
                    this.viewSwiper.slideTo(this.viewSwiper.slides.length - 1, 1000);
                    return
                }
                this.viewSwiper.slidePrev()
            })
        },
        arrowRight(e) {
            e.preventDefault()
            this.$nextTick(() => {
                if (this.viewSwiper.activeIndex == this.viewSwiper.slides.length - 1) {
                    this.viewSwiper.slideTo(0, 1000);
                    return
                }
                this.viewSwiper.slideNext()
            })  
        },
        updateNavPosition() {
            let previewSwiperWidth = this.previewSwiper.$el[0].parentElement.offsetWidth
            let slideWidth = this.previewSwiper.slides[0].swiperSlideSize
            this.previewImgSelected = this.viewSwiper.activeIndex
            if (this.previewImgSelected > this.previewSwiper.activeIndex) {
                var thumbsPerNav = Math.floor(previewSwiperWidth/slideWidth)-2
                this.previewSwiper.slideTo(this.previewImgSelected-thumbsPerNav)
            } else {
                this.previewSwiper.slideTo(this.previewImgSelected)
            }
        },
        thumbMoved(e) {
            var imgSrc = this.bannerList[this.viewSwiper.activeIndex]
            imgSrc = this.special=='10' && this.viewSwiper.activeIndex == 0 ? null : imgSrc
            this.$refs.preview.thumbMoved(e, imgSrc);
        },
        thumbLeaved() {
            this.$refs.preview.thumbLeaved();
        },
        forbidImgDrag(e) {
            e.preventDefault()
        }
    }
}
</script>
<style lang="less">
    .pc-slide {
        width: 500px;
        margin: 0 auto;
    }
    .view{
        position: relative;
    }
    .view .arrow-left {
        background: url(../../assets/imgs/index_tab_l.png) no-repeat left top;
        position: absolute;
        left: 10px;
        top: 50%;
        margin-top: -25px;
        width: 28px;
        height: 51px;
        z-index: 10;
    }
    #banner  .view .video{
        position: absolute;
        width: 80px;
        height: 80px;
        top:50%;
        left:50%;
        margin-top:-40px;
        margin-left:-40px;
    }
    .view .arrow-right {
        background: url(../../assets/imgs/index_tab_r.png) no-repeat left bottom;
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -25px;
        width: 28px;
        height: 51px;
        z-index: 10;
    }
    #banner .view{
        // overflow: hidden;
        .swiper-container {
            img{
                vertical-align: middle;
            }
            .boxImg{
                height:450px;
            }
        }
        .swiper-wrapper{
            height: auto;
        }
        .swiper-slide{
            height: 450px;
            background: url(../../assets/imgs/bs.png);
            text-align: center;
            overflow: hidden;
            position: relative;
            .bigmask{
                position: absolute;
                left: 0;
                top:0;
                width: 100%;
                height:100%;
                background: rgba(0,0,0,.8);
            }
        }
    }
    .swiper-wrapper{
        height: 86px;
    }
    .preview {
        width: 100%;
        margin-top: 30px;
        height: 86px;
        position: relative;
    }

    .preview .swiper-container {
        width: 500px;
        height: 82px;
        margin-left: 35px;
    }

    .preview .swiper-slide {
        width: 80px;
        height: 70px;
        margin-right:10px;
        cursor:pointer;
        text-align: center;
        position: relative;
        img{
            max-width: 100%;
            max-height: 100%;
            vertical-align: middle;
        }
        .imgmask{
            position: absolute;
            left:0;
            top:0;
            width:80px;
            height: 70px;
            background: rgba(0,0,0,.8);
        }
    }

    .preview .slide6 {
        width: 82px;
    }

    .preview .arrow-left {
        background: url(../../assets/imgs/feel3.png) no-repeat 3px 25px #eceef3;
        position: absolute;
        left: 10px;
        width: 20px;
        border:1px solid #979797;
        height: 70px;
        z-index: 10;
    }

    .preview .arrow-right {
        background: url(../../assets/imgs/feel4.png) no-repeat 5px 25px #eceef3;
        position: absolute;
        right: 10px;
        width: 20px;
        border:1px solid #979797;
        height: 70px;
        z-index: 10;
    }

    .preview img {
        padding: 1px;
        height: 86px;
    }
    .preview .active-nav{
        border: 1px solid #d8d8d8;
    }
    .preview .active-nav img {
        padding: 0;
    }
    #banner{
        .swiper-container {
            height: 450px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/banner.vue